import { useFormContext, useWatch } from '@dagens/frontend-forms';
import { useTranslation } from '@dagens/frontend-i18n';
import { BottomActions, Icon } from '@dagens/carrot';
import { AddCustomerFormValues } from '../types';

type Props = {
  onSubmit: (data: AddCustomerFormValues) => void;
};

export const AddCustomerStartNextButton = ({ onSubmit }: Props) => {
  const { t } = useTranslation();
  const { handleSubmit } = useFormContext<AddCustomerFormValues>();
  const state = useWatch<AddCustomerFormValues>();
  const isValid = state.organization && typeof state.organization !== 'string';

  return (
    <BottomActions.Submit onClick={handleSubmit(onSubmit)} disabled={!isValid}>
      {t('producer:AddCustomer.continueCreation')}
      <Icon icon="forward" size="small" />
    </BottomActions.Submit>
  );
};
